import {
  AnyAccountId,
  RoomContextId,
  StreamId,
  StreamIdentity,
  StreamType
} from "../interface";
import {
  ROOM_STAGE_VIDEO_MEDIA_STREAM_TYPE,
  ROOM_STAGE_VIDEO_STREAM_TYPE
} from "../const";

export class StreamSpecs {
  private static DELIMETER = "_";
  private static TYPES: Record<StreamType, true> = {
    camMic: true,
    screen: true,
    localVideoFile: true,
    localAudioFile: true
  };

  static identity(streamId: StreamId): StreamIdentity {
    const streamId0 = streamId.split(StreamSpecs.DELIMETER)[0];
    if (!streamId0) {
      throw new Error("Invalid streamId");
    }

    const streamId1 = Number(streamId0);

    if (Number.isSafeInteger(streamId1)) {
      return streamId1 as StreamIdentity;
    }

    return streamId0 as StreamIdentity;
  }

  // 'Stream Id' is exactly the one built by 'ofType'
  // for the given identity and 'Room Context'
  static isOwn(
    streamId: StreamId,
    identity: StreamIdentity,
    roomContextId: RoomContextId
  ): boolean {
    const type = StreamSpecs.type(streamId);

    return (
      Object.prototype.hasOwnProperty.call(StreamSpecs.TYPES, type) &&
      StreamSpecs.ofType(identity, type, roomContextId) === streamId
    );
  }

  static isOfType(streamId: StreamId, type: StreamType): boolean {
    return streamId.split(StreamSpecs.DELIMETER)[1] === type;
  }

  static ofType(
    identity: StreamIdentity,
    type: StreamType,
    roomContextId: RoomContextId
  ): StreamId {
    return [identity, type, roomContextId].join(
      StreamSpecs.DELIMETER
    ) as StreamId;
  }

  static roomContextId(streamId: StreamId): RoomContextId {
    const roomContextId = streamId.split(StreamSpecs.DELIMETER)[2];
    if (!roomContextId) {
      throw new Error("Invalid streamId");
    }

    return roomContextId as RoomContextId;
  }

  static type(streamId: StreamId): StreamType {
    return streamId.split(StreamSpecs.DELIMETER)[1] as StreamType;
  }

  static isVideoMediaStream(streamId: StreamId) {
    return ROOM_STAGE_VIDEO_MEDIA_STREAM_TYPE.includes(
      StreamSpecs.type(streamId)
    );
  }

  static isVideoStream(streamId: StreamId) {
    return ROOM_STAGE_VIDEO_STREAM_TYPE.includes(StreamSpecs.type(streamId));
  }

  static isAudiable(
    streamId: StreamId,
    streamAccountId: AnyAccountId,
    accountId?: null | AnyAccountId
  ) {
    return (
      !StreamSpecs.isOfType(streamId, "camMic") || accountId !== streamAccountId
    );
  }
}
